// extracted by mini-css-extract-plugin
export default {"profile_picture":"UsersLikesCircle_profile_picture__Fvh6Q","users_likes_circle":"UsersLikesCircle_users_likes_circle__GysSK","total_likes":"UsersLikesCircle_total_likes__rmA8R"};